import { cssRaw, cssRule, fontFace } from 'typestyle';
import { fontBody, fontHeading, fontIcons } from './font';
import {em, important, percent, px, quote, url, viewHeight} from 'csx';
import { colorSlate } from './color';
import { transitionQuickEase } from './transition';
import { constantPlayerHeight } from './constant';
import {BASE_PX} from '../constants';

export const injectGlobal = ({ 
  fontBodyURL = 'avant-garde-bold.otf',
  fontHeadingURL = 'Campton-SemiBold.otf',
  fontIconsTTFURL = 'hookd-icons.ttf?qqpuzd',
  fontIconsWOFFURL = 'hookd-icons.woff?qqpuzd',
  fontIconsSVGURL = 'hookd-icons.svg?qqpuzd#hookd-icons'
}) => {
  // TODO fix styles
  // fontFace({
  //   fontFamily: quote(fontHeading),
  //   fontStyle: 'normal',
  //   fontWeight: 'bold',
  //   src: `${url(fontHeadingURL)}`,
  // });

  cssRule('html, body', {
    margin: 0,
    padding: 0,
    height: viewHeight(100),
    minHeight: px(568),
    width: percent(100),
    fontFamily: `${quote(fontBody)}, 'Segoe UI', sans-serif`,
    fontSize: px(BASE_PX),
    lineHeight: em(1.375),
    color: colorSlate.toString(),
    backgroundColor: colorSlate.darken(0.075).toString()
  });

  cssRule('*', {
    boxSizing: 'border-box',
    minHeight: 0,
    minWidth: 0,
  });

  cssRule('body > main', {
    minHeight: viewHeight(100),
    position: 'relative',
  });

  cssRule('h1, h2, h3, h4, h5, h6', {
    fontFamily: `${quote(fontHeading)}, ${quote(fontBody)}, 'Segoe UI', sans-serif`,
    fontWeight: 'bold',
    letterSpacing: em(-0.0625),
    lineHeight: em(1.0625)
  });

  cssRule('a', {
    transition: `color 0.1s linear`,
    textDecoration: 'none'
  });

  cssRule('p', {
    margin: '1em 0 1.25em 0',
    lineHeight: em(1.375),
  });

  cssRule('button', {
    cursor: 'pointer'
  });

  cssRule('#hubspot-messages-iframe-container', {
    transition: `bottom ${transitionQuickEase}`,
  });

  cssRule('#hubspot-messages-iframe-container[data-shunted]', {
    bottom: important(constantPlayerHeight.toString()),
  });
};